export const en = {
  // Navigation
  nav: {
    home: 'Home',
    findHairstylist: 'Search',
    forum: 'Girls Forum',
    about: 'About',
  },
  // Header
  header: {
    account: 'Account',
    connected: 'Connected',
    hairstylistAccount: 'Hairstylist account',
    clientAccount: 'Client account',
    viewProfile: 'View my hairstylist profile',
    favorites: 'My favorites',
    reviews: 'My reviews',
    myPosts: 'My questions',
    favoritePosts: 'My favorite questions',
    accountSettings: 'My account',
    logout: 'Logout',
    login: 'Login',
    signup: 'Sign up',
    addHairstylist: 'Add a hairstylist profile',
    messages: 'Messages',
    iAmProvider: 'I offer a service',
    dashboard: 'Dashboard',
    manageSubscription: 'Manage my subscription',
    verifyEmail: 'Verify an email',
    pendingEmails: 'Pending emails',
    dashboardAnalytics: 'Dashboard Analytics',
    chooseProviderType: 'Choose your service type',
    editProfile: 'Edit my profile',
    upgradeToPro: 'Upgrade to PRO',
  },
  // Home Page
  home: {
    heroTitle: 'Find your',
    heroAfro: 'afro hairstylist',
    heroClicks: '',
    heroSubtitle: 'and other independent beauty professionals',
    findButton: "I'm looking for a beauty pro!",
    signupButton: "I offer a service, sign me up!",
    checking: 'Checking...',
    lastProfiles: 'Latest profiles created',
    loading: 'Loading...',
    mockupAlt: 'App preview',
    existingProfileTitle: 'You already have a hairstylist profile ✨',
    existingProfileMessage: 'Your account is already associated with a profile in the directory. You can view and edit it directly.',
    viewMyProfile: 'View my profile',
    close: 'Close',
    statsText: '120+ afro hairstylists referenced • The largest database in Belgium',
    statsTextMobile: 'The largest afro hairstylist referral database in Belgium',
    newBadge: 'New to Chérie Coiffer',
    newBadgeAriaLabel: 'Go to New to Chérie Coiffer section',
    providerHair: 'Hair',
    providerNails: 'Nails',
    providerMakeup: 'Makeup',
    providerEyelash: 'Eyelashes',
    providerSale: 'Vendor',
    selectProviderType: 'What type of service do you offer?',
  },
  // Search Page
  search: {
    title: 'Find a hairstylist',
    filters: 'Filters',
    sort: 'Sort',
    sortBy: 'Sort by',
    ascending: 'Ascending',
    descending: 'Descending',
    photosAvailable: 'Photos available',
    country: 'Country',
    allCountries: 'All countries',
    noCountryFound: 'No country found',
    belgium: 'Belgium',
    france: 'France',
    switzerland: 'Switzerland',
    city: 'City',
    cityPlaceholder: 'Search for a city...',
    name: 'Hairstylist name',
    namePlaceholder: 'Search by name...',
    services: 'Services',
    categories: 'Categories',
    kidsAccepted: 'Accepts children',
    menAccepted: 'Accepts men',
    canTravel: 'Can travel',
    hasPhotos: 'With photos',
    results: 'results',
    noResults: 'No results found',
    clearFilters: 'Reset filters',
    apply: 'Apply',
    close: 'Close',
    generalInfo: 'General information',
    sortByDistance: 'Distance',
    sortByRating: 'Rating',
    sortByUpdated: 'Last updated',
    sortByCreated: 'Creation date',
    refineSearch: 'Refine search',
    searchByCityService: 'Search by city, service...',
    searching: 'Searching…',
    removeCity: 'Remove {city}',
    coiffesChildren: 'Styles children',
    coiffesMen: 'Styles men',
    canTravelLabel: 'Can travel',
    photosAvailableLabel: 'Photos available',
    sortDefault: 'Default',
    sortDistance: 'Distance',
    sortRating: 'Rating',
    sortAlphabetical: 'Alphabetical order',
    sortCreatedAt: 'Creation date',
    sortAscending: 'Sort ascending',
    sortDescending: 'Sort descending',
    expand: 'Expand',
    collapse: 'Collapse',
    serviceTypes: 'Service types',
    loadingCategories: 'Loading categories…',
    reset: 'Reset',
    otherServices: 'Other services',
    viewList: 'List',
    viewMap: 'Map',
    activeFilter: 'active filter',
    youAreProvider: 'Are you a {provider}?',
    signupHere: 'Sign up here.',
    found: 'found',
    foundSingular: 'found',
    providers: 'providers',
    provider: 'provider',
    providerRegistration: 'Provider registration',
    allResultsShown: 'You\'ve seen everything ✨',
    profileNotPublished: 'Your profile is not published yet. Activate your subscription to be visible.',
    activateProfile: 'Activate my profile',
  },
  // Hairstylist Card
  card: {
    canTravel: '(can travel)',
    photosAvailable: 'Photos available',
    photos: 'Photos',
    contact: 'Contact',
    viewProfile: 'View profile',
  },
  // Hairstylist Detail
  detail: {
    back: 'Back',
    addToFavorites: 'Add to favorites',
    removeFromFavorites: 'Remove from favorites',
    contact: 'Contact',
    services: 'Services',
    description: 'Description',
    gallery: 'Photo gallery',
    reviews: 'Client reviews',
    rating: 'Rating',
    noReviews: 'No reviews yet',
    writeReview: 'Write a review',
    editReview: 'Edit my review',
    deleteReview: 'Delete my review',
    reviewPlaceholder: 'Write your review here...',
    submitReview: 'Publish',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    save: 'Save',
    freeProfile: 'Free profile (limited)',
    proProfile: 'PRO profile',
    emptyState: 'Select a card to view details',
    generalInfo: 'General information',
    profileName: 'Profile name',
    notSpecified: 'Not specified',
    deleteProfile: 'Delete profile',
    mainCity: 'Main city',
    citiesServed: 'Cities served',
    presentation: 'Presentation',
    coordinates: 'Contact details',
    primaryContact: 'Primary social network',
    photos: 'Photos',
    profilePhoto: 'Profile photo',
    galleryPhoto: 'Gallery',
    servicesOffered: 'Services offered',
    loginToReview: 'Log in to leave a review',
    giveReview: 'Leave a review',
    confirmDeleteReview: 'Are you sure you want to delete your review?',
    deleting: 'Deleting...',
    anonymousUser: 'Anonymous user',
    yourReview: '(Your review)',
    unknownDate: 'Unknown date',
    identificationCode: 'Identification code:',
    prevPhoto: 'Previous photo',
    nextPhoto: 'Next photo',
    errorDeleteProfile: 'Error while deleting profile.',
    errorDelete: 'Error while deleting',
  },
  // Posts
  posts: {
    title: 'Girls Forum',
    subtitle: 'Here you can ask questions, share your experiences, and help others.',
    createPost: 'Create a question',
    askQuestion: '+ Ask a question',
    editPost: 'Edit question',
    deletePost: 'Delete question',
    noPosts: 'No questions yet',
    writeComment: 'Write a comment',
    addComment: 'Add a comment',
    commentPlaceholder: 'Write a comment...',
    publish: 'Publish',
    seeMoreComments: 'See {count} previous comments',
    seeLessComments: 'See less',
    addPhotos: 'Add photos',
    titlePlaceholder: 'Your question title',
    contentPlaceholder: 'Your question content...',
    loading: 'Loading...',
  },
  // Profile
  profile: {
    title: 'My profile',
    favorites: 'My favorites',
    reviews: 'My reviews',
    myPosts: 'My questions',
    favoritePosts: 'My favorite questions',
    noFavorites: 'You don\'t have any favorites yet',
    noReviews: 'You haven\'t written any reviews yet',
    noPosts: 'You haven\'t created any questions yet',
    unpublishedTitle: 'Profile not published',
    unpublishedMessage: 'Your profile is not yet visible on the platform. Complete your payment to publish it.',
    signInToActivate: 'Sign in to activate your profile',
    signInToActivateText: 'You received an email to activate your profile. Sign in to continue.',
    finalizePayment: 'Complete payment',
  },
  // Payment
  payment: {
    title: 'Boost your professional visibility',
    subtitle: 'Choose the plan that suits you',
    freeTitle: 'Free Profile',
    freeSubtitle: 'Ideal for starting to be visible, with limited features.',
    proTitle: 'PRO Profile',
    proSubtitle: 'Full version of the profile, to boost your visibility.',
    popular: 'Most popular',
    price: '{price}/month',
    perMonth: '/month',
    free: 'Free',
    createFree: 'Start for free',
    activatePro: 'Activate my subscription',
    freeNote: 'Stay free as long as you want.',
    priceProtection: 'Prototype price: as long as you stay subscribed, your rate never increases.',
    creating: 'Creating...',
    redirecting: 'Redirecting...',
    successTitle: 'Profile created successfully!',
    successMessage: 'Congratulations! Your free profile has been created. You can now start being visible in our directory.',
    viewProfile: 'View my profile',
    backHome: 'Back to home',
    errorMissingData: 'Unable to create profile: profile data is missing. Please restart the registration.',
    errorPaymentData: 'Unable to start payment: profile data is missing. Please restart the registration.',
    errorEmail: 'Unable to start payment: account email address is missing.',
    errorCheckout: 'Error creating payment session. Please try again.',
    errorProfileCreation: 'Error creating profile',
    feature1: 'Visible in directory',
    feature2: 'Name + city + services visible',
    feature3: 'Full photo gallery',
    feature4: 'Client reviews visible',
    feature5: 'Average rating displayed',
    feature6: 'Priority in search results',
    feature7: 'Access to a simple profile',
    feature8: 'Verified PRO badge',
    feature9: 'Priority support',
    feature10: 'Ability to upgrade to PRO anytime',
    // Page 3 – Account created, PRO option
    successAccountCreated: 'Your account has been created! 🎉',
    successSubtitle: 'You can already use the platform freely.',
    successProIntro: 'Want more visibility? Discover the PRO option:',
    proCardTitle: 'PRO Profile – €9.99/month',
    proCardSubtext: 'Instant visibility boost',
    proFeaturePriority: 'Always priority in search results',
    proFeatureGallery: 'Photo gallery visible to everyone',
    proFeatureReviews: 'Reviews & ratings visible',
    proFeatureDashboard: 'Dashboard & statistics',
    proFeatureServices: 'Detailed services list',
    proFeatureCancel: 'Cancel anytime',
    goProButton: 'Go PRO now',
    securityText: 'Secure payment (SSL & Stripe) – No hidden fees',
    skipUpgrade: 'No thanks, stay on FREE',
    errorProfileNotFound: 'Error: profile not found. Please restart the registration.',
    errorUserNotConnected: 'Error: user not connected.',
    signInToActivate: 'Sign in to activate your profile',
    signInToActivateText: 'You received an email to activate your profile. Sign in with your account to continue.',
    signIn: 'Sign in',
    errorStripeNotConfigured: 'Stripe is not configured yet. Please set REACT_APP_STRIPE_PUBLISHABLE_KEY or replace STRIPE_PUBLISHABLE_KEY in PaymentPage.jsx.',
    errorStripeInit: 'Unable to initialize Stripe. Please ensure the script https://js.stripe.com/v3 is loaded.',
    errorRedirectStripe: 'Error redirecting to Stripe. Please try again.',
    // Subscription Success Page
    subscriptionActivated: 'Subscription activated',
    subscriptionActivatedSubtitle: 'Your profile is now visible in the directory. Clients can find you, like you, and leave reviews 💗',
    subscriptionActiveStatus: 'Subscription: ACTIVE',
    subscriptionDetails: 'Subscription details',
    plan: 'Plan:',
    professionalPlan: 'Professional Subscription — €9.99/month',
    autoRenewal: 'Auto-renewal:',
    enabled: 'Enabled',
    nextInvoice: 'Next invoice:',
    manageSubscription: 'Manage my subscription',
    nextSteps: 'Next Steps',
    completeProfile: 'Complete your profile',
    completeProfileDescription: 'Add more details to attract more clients',
    addPhotos: 'Add photos',
    addPhotosDescription: 'Show your best creations in your gallery',
    addPhotosButton: 'Add photos',
    inviteReviews: 'Invite your clients to leave a review',
    inviteReviewsDescription: 'Share your profile link to receive reviews',
    copyReviewLink: 'Copy my review link',
    linkCopied: 'Link copied to clipboard!',
    communityMessage: 'You are now part of the Chérie Coiffer community 💜',
    proudMessage: 'We are so proud to have you with us.',
    ifYouHaveQuestion: 'If you have a question:',
    accessStylistSpace: 'Access my Stylist Space →',
    germanMandatoryTitle1: 'Congratulations, your profile is created!',
    germanMandatoryTitle2: 'Complete your registration',
    germanMandatorySubtitle: 'Payment is required to publish your profile on the platform',
    germanReadyTitle: 'Almost there!',
    germanReadySubtitle: 'Activate your profile to appear on the map and be visible to clients.',
    germanPreviewLabel: 'This is how clients will see you',
    germanProVisibility: 'PRO Visibility',
    germanEarlyAccess: 'Early Access Price. Cancel anytime. No hidden fees.',
    germanBenefitMap: 'Appear on the city map',
    germanBenefitSearch: 'Be searchable by service',
    germanBenefitPhotos: 'Show your photos & reviews',
    germanBenefitStats: 'Access your performance stats',
    germanActivateButton: 'Activate my profile',
    germanActivateNote: 'Most stylists activate within 2 minutes.',
    paywallPreviewLabel: 'Preview of your public profile',
    paywallCtaGoLive: 'Activate my profile now',
    paywallPillRecommended: 'Recommended',
    paywallMicrocopy: 'Cancel anytime · No hidden fees',
    finalizePay: 'Complete and pay',
    proFeatureVerifiedBadge: 'Verified PRO badge',
    proFeatureSearchable: 'Clients can find you by city and service',
  },
  // Account Settings
  account: {
    title: 'My account',
    accountInfo: 'My information',
    username: 'Username',
    email: 'Email',
    creationDate: 'Creation date',
    actions: 'Actions',
    changePassword: 'Change my password',
    deleteAccount: 'Delete my account',
    subscription: 'My subscription',
    subscriptionActive: 'Active subscription',
    subscriptionInactive: 'No active subscription',
    deleteWarning: 'Warning',
    deleteWarningMessage: 'If you delete your account and you have an active subscription, it will be cancelled and you will no longer be able to access your PRO profile.',
    confirmDelete: 'Confirm deletion',
    cancel: 'Cancel',
    passwordModal: {
      title: 'Change my password',
      currentPassword: 'Current password',
      newPassword: 'New password',
      confirmPassword: 'Confirm new password',
      change: 'Change',
      cancel: 'Cancel',
    },
  },
  // Common
  common: {
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    search: 'Search',
    filter: 'Filter',
    clear: 'Clear',
    submit: 'Submit',
    confirm: 'Confirm',
    notSpecified: 'Not specified',
  },
  // Chat
  chat: {
    button: 'Chat',
    title: 'Chat with us',
    subtitle: 'We usually respond within 24 hours',
    namePlaceholder: 'Your name',
    emailPlaceholder: 'Your email',
    startChat: 'Start conversation',
    messagePlaceholder: 'Type your message...',
    emptyState: 'Start the conversation! 👋',
    close: 'Close',
  },
  // Auth Modal
  auth: {
    login: 'Login',
    signup: 'Sign up',
    resetPassword: 'Reset password',
    username: 'Username',
    usernamePlaceholder: 'Ex: marie_braids78',
    email: 'Email',
    emailOrUsername: 'Email or username',
    emailPlaceholder: 'Ex: marie@example.com',
    emailOrUsernamePlaceholder: 'Ex: marie_braids78 or marie@mail.com',
    password: 'Password',
    passwordPlaceholder: 'At least 6 characters',
    confirmPassword: 'Confirm password',
    confirmPasswordPlaceholder: 'Re-enter your password',
    forgotPassword: 'Forgot password?',
    sendLink: 'Send link',
    connect: 'Log in',
    signupButton: 'Sign up',
    noAccount: 'No account yet? Sign up',
    hasAccount: 'Already have an account? Log in',
    loading: 'Loading...',
    sending: 'Sending...',
    resendLink: 'Resend link',
    resetEmailSent: 'A password reset email has been sent to you. Please check your mailbox.',
    verificationEmailResent: 'Verification email resent! Please check your mailbox.',
    pleaseEnterEmail: 'Please enter your email address.',
    usernameRequired: 'Username is required.',
    usernameInvalid: 'Username can only contain letters, numbers, hyphens (-), underscores (_) and dots (.).',
    emailInvalid: 'The email address is not valid. Please enter a correct email address.',
    passwordMinLength: 'Password must contain at least 6 characters.',
    passwordsDontMatch: 'Passwords do not match.',
    usernameTaken: 'This username is already taken. Please choose another one.',
    emailTaken: 'This email is already used. Please log in or use another email.',
    errorOccurred: 'An error occurred',
    networkError: 'Connection problem. Check your internet connection (Wi‑Fi or mobile data) and try again.',
    verificationEmailError: 'Error sending verification email.',
  },
  // Language
  language: {
    french: 'Français',
    english: 'English',
    german: 'Deutsch',
    dutch: 'Nederlands',
  },
  // Signup Page
  signup: {
    alreadyHairstylistTitle: 'You already have a hairstylist profile ✨',
    alreadyHairstylistMessage: 'Your account is already associated with a profile in the directory. You can view or edit it directly.',
    viewMyProfile: 'View my profile',
    welcomeTitle: 'Welcome, beautiful!',
    welcomeSubtitle: 'Complete this form to join our directory.',
    chatWelcomeMessage: 'Welcome to Chérie Coiffer! 💜 Thank you for joining our community of hairstylists. If you have any questions, just reply to this message — we\'re here for you.',
    infoBox: 'No need to do it perfectly, you will always be able to modify this information later.',
    createAccountTitle: 'Create your account',
    createAccountSubtitle: 'Last step: create your account to finalize your registration.',
    createAccountSubtitle2: 'This information will allow you to log in and manage your profile.',
    section1Title: 'General information',
    section1Subtitle: 'Some information to present your profile.',
    profileName: 'Profile name',
    profileNamePlaceholder: 'Ex: Aya Braid Studio',
    country: 'Country',
    selectCountry: 'Select a country',
    noCountryFound: 'No country found',
    mainCity: 'Main city',
    mainCityPlaceholder: 'Ex: Paris',
    canTravel: 'I can travel to the client\'s home',
    addCity: 'Add a served city',
    presentation: 'Presentation',
    presentationPlaceholder: 'Explain how you work, what you offer, your services…',
    section2Title: 'Contact information',
    section2Subtitle: 'How can clients contact you?',
    primaryContact: 'Primary social network',
    selectPrimary: 'Select',
    primaryContactHelp: 'The primary network is shown on your card. Your other contact options are visible on your profile page.',
    section3Title: 'Photos',
    section3Subtitle: 'Add a portrait and some work samples (max. 6).',
    profilePhoto: 'Profile photo',
    addPhoto: 'Add photo',
    remove: 'Remove',
    section4Title: 'What services do you offer?',
    section4Subtitle: 'Select all corresponding services.',
    loadingCategories: 'Loading categories…',
    username: 'Username',
    usernamePlaceholder: 'Ex: marie_braids78',
    email: 'Email',
    emailPlaceholder: 'Ex: marie@example.com',
    password: 'Password',
    passwordPlaceholder: 'At least 6 characters',
    confirmPassword: 'Confirm password',
    confirmPasswordPlaceholder: 'Re-enter your password',
    cancel: 'Cancel',
    next: 'Next',
    previous: 'Previous',
    submitting: 'Sending…',
    continue: 'Continue',
    validateProfile: 'Validate my profile',
    creating: 'Creating…',
    createAccountAndJoin: 'Create my account and join the directory',
    confirmCancel: 'Are you sure you want to cancel your registration?',
    progressStep1: 'Profile creation',
    progressStep2: 'Account creation',
    progressStep3: 'Confirmation',
    progressStepAria: 'Step {step}: {label}',
    validation: {
      pleaseCompleteFields: 'Please complete the following fields: {fields}.',
      atLeastOneService: 'At least one service',
      atLeastThreePhotos: 'At least 3 photos of your work',
      completeProfileFirst: 'Please complete your profile (step 1) first before creating your account. You may have opened the account creation page directly.',
      atLeastOneContact: 'At least one contact detail',
      primaryContactRequired: 'Primary social network',
      confirmPasswordLabel: 'Confirm password',
    },
    errorLoadCategories: 'Unable to load categories.',
    errorCountryNotSupported: 'This country is not yet supported. Please choose a city in Europe or French-speaking Africa.',
    errorImagesOnlyProfile: 'Only images are allowed for the profile photo.',
    errorImagesOnlyGallery: 'Only images are allowed for the gallery.',
    errorProfileCreation: 'Error creating profile. Please try again.',
    creatingAccount: 'Creating your account...',
    errorEmailVerification: 'Error verifying email. Please try again.',
    errorGeneric: 'An error occurred. Please try again.',
    errorFormNotFound: 'Error: form not found. Please refresh the page.',
    errorOccurred: 'An error occurred. Please try again.',
    contactFields: {
      instagram: 'Instagram',
      instagramPlaceholder: 'Instagram handle',
      tiktok: 'TikTok',
      tiktokPlaceholder: 'TikTok handle',
      whatsapp: 'WhatsApp',
      whatsappPlaceholder: 'Phone number',
      phone: 'Phone',
      phonePlaceholder: 'Phone number',
      externalLink: 'External link',
      externalLinkPlaceholder: 'Ex: Calendly link',
    },
  },
  // Footer
  footer: {
    navigation: 'Navigation',
    home: 'Home',
    hairstylists: 'Hairstylists',
    posts: 'Posts',
    information: 'Information',
    about: 'About',
    faq: 'FAQ',
    contact: 'Contact',
    legal: 'Legal notice',
    refund: 'Refund policy',
    followUs: 'Follow us',
    instagram: 'Instagram',
    allRightsReserved: 'All rights reserved',
  },
  // Legal Page
  legal: {
    title: 'Legal Notice',
    lastUpdate: 'Last updated: December 4, 2025',
    editor: {
      title: '1. Site editor',
      name: 'Chérie, Coiffer ?',
      editor: 'Project edited by:',
      editorName: 'Christelle Kabemba',
      country: 'Belgium',
      email: 'Email:',
    },
    hosting: {
      title: '2. Hosting',
      text: 'The site is hosted by:',
      provider: 'Firebase Hosting – Google LLC',
      address: '1600 Amphitheatre Parkway, Mountain View, CA 94043, USA.',
    },
    purpose: {
      title: '3. Site purpose',
      description: '<strong>Chérie, Coiffer ?</strong> is a digital directory facilitating the search for afro hairstylists in Belgium and elsewhere. The goal is to bring together, in one place:',
      items: [
        'hairstylist profiles',
        'their public Instagram / TikTok accounts',
        'their publicly visible services',
        'their non-private location information',
      ],
      goal: 'The site aims to improve the visibility of hairstylists and simplify the lives of clients.',
    },
    profiles: {
      title: '4. Creation of hairstylist profiles',
      public: {
        title: '4.1 Profiles generated from public information',
        text: 'To make it easier for clients to discover active hairstylists in Belgium, some profiles may be created from <strong>public and freely accessible</strong> information, such as:',
        items: [
          'Instagram public pseudonym or name',
          'public profile photo',
          'publicly visible services',
          'city or service area indicated',
        ],
        privacy: 'No private information (personal address, private number, conversations, etc.) is collected or published.',
      },
      rights: {
        title: '4.2 Right to modify, delete and manage profile',
        text: 'Any hairstylist can at any time:',
        items: [
          'request <strong>immediate deletion</strong> of their profile,',
          'request <strong>modification</strong> of their information,',
          '<strong>claim</strong> their profile to manage it personally.',
        ],
        contact: 'To do this, simply send a message to the following address:',
        deletion: 'Deletion will be carried out as soon as possible, without justification required.',
      },
    },
    accounts: {
      title: '5. User accounts (clients and hairstylists)',
      text: 'Users can create an account to:',
      items: [
        'manage a professional profile,',
        'add hairstylists to favorites,',
        'ask questions in the forum,',
        'leave reviews (if the option is enabled).',
      ],
      responsibility: 'Each user remains responsible for the information they publish.',
    },
    data: {
      title: '6. Data collection and processing',
      text1: 'The only data collected automatically is anonymous and statistical (via Google Analytics or equivalent). No sensitive data is collected.',
      text2: 'No data will be sold or transferred.',
    },
    gdpr: {
      title: '7. Your rights (GDPR)',
      text: 'In accordance with GDPR, you have the right to:',
      items: [
        'access your data,',
        'rectification,',
        'objection,',
        'erasure ("right to be forgotten").',
      ],
      contact: 'For any request:',
    },
    intellectual: {
      title: '8. Intellectual property',
      text: 'The design, logo, texts and code of the site belong to Chérie, Coiffer ?. Instagram profile photos belong to their respective owners and are only used as <strong>non-commercial thumbnails</strong> to link to their public pages.',
    },
    liability: {
      title: '9. Liability',
      text: 'Chérie, Coiffer ? is not responsible for:',
      items: [
        'the quality of services provided by hairstylists,',
        'incorrect information on profiles from public sources,',
        'decisions made by clients.',
      ],
    },
    contact: {
      title: '10. Contact',
      text: 'For any question or request concerning your data or your profile:',
    },
  },
  // FAQ Page
  faq: {
    title: 'Frequently Asked Questions (FAQ)',
    lastUpdate: 'Last updated:',
    pro: {
      title: '1. PRO Subscription',
      whatIs: {
        title: '1.1 What is the PRO subscription?',
        text: 'The PRO subscription is a monthly subscription of <strong>€9.99/month</strong> that allows providers (hairstylists, nail artists, MUAs, eyelash artists) to benefit from premium features on Chérie Coiffer.',
      },
      benefits: {
        title: '1.2 What are the benefits of the PRO subscription?',
        text: 'PRO providers benefit from:',
        items: [
          'Increased visibility in search results',
          'Priority display in lists',
          'Visible "PRO" status on their profile',
          'Access to detailed statistics',
        ],
      },
      subscribe: {
        title: '1.3 How do I subscribe to the PRO subscription?',
        text: 'To subscribe to the PRO subscription, you must first create a provider profile on Chérie Coiffer. Once your profile is created, you will be redirected to the payment page where you can choose the PRO subscription and make payment via Stripe.',
      },
      cancel: {
        title: '1.4 How can I cancel my PRO subscription?',
        text: 'To cancel your PRO subscription, please contact us by email at',
        text2: 'indicating your cancellation request. We will process your request as soon as possible.',
        important: 'Important:',
        importantText: 'Cancellation will take effect at the end of the current billing period. You will continue to benefit from PRO benefits until the end of this period.',
      },
      paymentFailed: {
        title: '1.5 What happens if my payment fails?',
        text: 'In case of payment failure, you will receive a notification email. You have a grace period of 7 days to update your payment method. If payment is not made within this period, your PRO subscription will be automatically deactivated and your account will revert to free (FREE) mode.',
      },
      refund: {
        title: '1.6 Can I get a refund?',
        text: 'Subscriptions are billed monthly. In case of cancellation, you will continue to benefit from PRO benefits until the end of the current billing period. No partial refund is made for the remaining period.',
      },
    },
    profile: {
      title: '2. Profile creation and management',
      create: {
        title: '2.1 How do I create a provider profile?',
        text: 'To create a provider profile, click on "I am a provider" in the menu, choose your service type (Hair, Nails, Makeup, Eyelashes), then follow the registration form steps.',
      },
      edit: {
        title: '2.2 Can I edit my profile after creation?',
        text: 'Yes, you can edit your profile at any time by logging into your account and accessing your profile edit page.',
      },
      delete: {
        title: '2.3 How do I delete my profile?',
        text: 'To delete your profile, contact us at',
        text2: 'Deletion will be carried out as soon as possible.',
      },
    },
    search: {
      title: '3. Search and filters',
      howTo: {
        title: '3.1 How do I search for a provider?',
        text: 'Use the search bar at the top of the page to search by name, service type, or city. You can also use advanced filters to refine your search.',
      },
      city: {
        title: '3.2 How does city filtering work?',
        text: 'City filtering only displays providers who have specified this city in their profile (main city or travel cities). Providers who can travel but have not specified your city will not be displayed in the results.',
      },
    },
    account: {
      title: '4. User account',
      create: {
        title: '4.1 How do I create an account?',
        text: 'You can create an account by clicking on "Login" then "Sign up". You can create an account as a client or directly as a provider.',
      },
      forgotPassword: {
        title: '4.2 I forgot my password',
        text: 'Click on "Login" then on "Forgot password" and follow the instructions to reset your password.',
      },
      delete: {
        title: '4.3 How do I delete my account?',
        text: 'You can delete your account from the "Account Management" page in your profile settings. This action is irreversible and will delete all your data.',
      },
    },
    reviews: {
      title: '5. Reviews and ratings',
      howTo: {
        title: '5.1 How do I leave a review?',
        text: 'To leave a review, you must be logged in and have viewed the provider\'s profile. Reviews must be respectful and based on a real experience.',
      },
      edit: {
        title: '5.2 Can I edit or delete my review?',
        text: 'Yes, you can edit or delete your reviews from your profile page in the "My reviews" section.',
      },
    },
    support: {
      title: '6. Contact and support',
      contact: {
        title: '6.1 How do I contact you?',
        text: 'For any question, request or problem, you can contact us by email at',
      },
      response: {
        title: '6.2 Response time',
        text: 'We strive to respond to all requests within 48 business hours.',
      },
    },
  },
  // About Page
  about: {
    title: 'About',
    lastUpdate: 'Last updated: December 4, 2025',
    mission: {
      title: 'Our mission',
      text1: '<strong>Chérie, Coiffer ?</strong> is a platform that facilitates the search for afro hairstylists in Belgium (and soon elsewhere). The idea is simple: bring together in one place all the hairstylists active on Instagram, TikTok or elsewhere, to help clients find exactly what they are looking for, without spending hours browsing social networks.',
      text2: 'Whether you\'re looking for someone near you, a specialist in a type of braids, or simply hair inspiration, our goal is to make this search simpler, clearer, and more accessible.',
    },
    why: {
      title: 'Why this project?',
      text1: 'After several years abroad, I returned to live in Belgium and quickly realized a problem: finding a reliable hairstylist had become extremely complicated.',
      text2: 'Everything goes through Instagram and TikTok, but if you don\'t know the right <strong>@</strong>, it\'s easy to miss a talented hairstylist… sometimes even the one who lives just two streets away from you.',
      text3: 'As a digital enthusiast, I decided to create a tool that centralizes this information in a simple, clear and transparent way.',
    },
    profiles: {
      title: 'How are profiles created?',
      text1: 'To make the platform immediately useful, some hairstylist profiles are created from <strong>public</strong> information visible on their social networks (pseudonym, public photos, displayed services, etc.).',
      text2: '<strong>Each hairstylist maintains total control over their profile:</strong>',
      items: [
        'claim their profile to manage it themselves;',
        'request information modifications;',
        'request immediate profile deletion, without justification.',
      ],
      text3: 'The goal is never to replace Instagram pages: simply to make them easier to find.',
    },
    name: {
      title: 'Why "Chérie, Coiffer ?"',
      text1: 'The name is a nod to a well-known phrase in the community:',
      quote: '« My dear, come, I\'ll do your hair »',
      text2: 'typical of neighborhoods like Matongé, where hairstylists approach clients.',
      text3: 'The site reflects this spirit: a warm, accessible space, designed for us.',
    },
    values: {
      title: 'Our values',
      items: [
        '<strong>Accessibility:</strong> allow everyone to find a hairstylist easily.',
        '<strong>Visibility:</strong> help talented hairstylists be better discovered.',
        '<strong>Transparency:</strong> profiles can be modified or deleted at any time.',
        '<strong>Simplicity:</strong> a clear platform, without complications.',
      ],
    },
    contact: {
      title: 'Contact',
      text: 'For any question, to modify or claim a profile, or to collaborate:',
    },
  },
  // Services and categories from Firestore
  // Codes correspond to codes in the database
  // Format: services.{CODE} or categories.{CODE}
  // Example: services.TRESSES_CORNBROWS = "Cornrows"
  // If a translation doesn't exist, the French label from DB will be used as fallback
  services: {
    // Translations will be added as needed
    // For now, French labels from DB are used as fallback
  },
  categories: {
    // Translations will be added as needed
    // For now, French labels from DB are used as fallback
  },
};

